<template>
      <div class="carousel-wrapper">
        <div class="carousel" v-on:scroll="setCurrentSlide">
          <div v-for="(image, index) in images" :key="index">
              <img class="carousel-image" :src="image.original" :alt="altText">
          </div>
        </div>
        <div class="carousel-pips">
            <i v-for="(image, index) in images" :key="index" @click="goToSlide(index)" class="carousel-pips__pip" :class="{ active: index === currentSlide }"></i>
        </div>
      </div>
</template>

<script>
export default {
    name: 'ImageCarousel',
    data() {
        return {
            currentSlide: 0,
            carousel: '',
        };
    },
    props: {
        images: {
            required: true,
            type: Array,
        },
        altText: {
            required: false,
            type: String,
            default: 'Product image',
        },
    },
    mounted() {
        this.carousel = this.$el.querySelector('.carousel');
    },
    methods: {
        setCurrentSlide() {
            this.currentSlide = this.carousel.scrollLeft / this.carousel.offsetWidth;
        },
        goToSlide(slideIndex) {
            const width = this.carousel.offsetWidth;
            this.carousel.scrollTo(width * slideIndex, 0);
        },
    },
};
</script>
